import { ActionReducerMap } from '@ngrx/store';
import { routerReducer } from '@ngrx/router-store';
import { headerReducer } from './features/header/header.reducers';
import { spinnerReducer } from './features/spinner/spinner.reducers';

export interface AppState {
  header: { title: '' };
  spinner: { isShow: boolean };
}

export const reducers: ActionReducerMap<any> = {
  router: routerReducer,
  header: headerReducer,
  spinner: spinnerReducer
};
